import { HierarchyFiltersState } from "@domain/model/HierarchyFiltersState";
import { IHierarchyFiltersService } from "@domain/services/IHierarchyFiltersService";
import { create } from "@movicoders/store";

export const useHierarchyFiltersService = create<IHierarchyFiltersService>(set => ({
  clearHierarchyFiltersState: () => set({ persistedState: undefined }),
  saveHierarchyFiltersState: (newState: HierarchyFiltersState) => set({ persistedState: newState })
})).build();
